import { render } from "./AdminNoAccessPage.vue?vue&type=template&id=2cea6660&scoped=true"
import script from "./AdminNoAccessPage.vue?vue&type=script&lang=js"
export * from "./AdminNoAccessPage.vue?vue&type=script&lang=js"

import "./AdminNoAccessPage.vue?vue&type=style&index=0&id=2cea6660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cea6660"]])

export default __exports__